import React from "react";
import { Formik, Field } from "formik";
import { Form } from "react-bootstrap";
import { isEmpty } from "lodash";
import { get } from "lodash";
import {
  FieldInput,
  FieldDropSide,
  SearchableList,
  FieldButtonGroup,
  FieldInputFormatted,
  UploadComponent,
  FieldTextarea,
  ManageRkaasLayout,
} from "../../../../components";

export const bankAccountTypeOptions = [
  {
    label: "Savings",
    value: 0,
  },
  {
    label: "Checking",
    value: 1,
  },
];

export const bankAccountStatusOptions = [
  {
    label: "Active",
    value: 0,
  },
  {
    label: "InActive",
    value: 1,
  },
];

function AccountDetailsContainer(props) {
  const {
    fields,
    setOuterFieldValue,
    outerValues,
    planList,
    planLoading,
    setIsModelOpen,
    modelIndex,
  } = props;

  const onFormSubmit = (values) => {
    setOuterFieldValue(`custodianAccountDetails.${modelIndex}`, values);
    setIsModelOpen(false);
  };
  const buttons = [
    {
      label: "Cancel",
      variant: "secondary",
      type: "button",
      onClick: () => {
        setIsModelOpen(false);
      },
    },
    {
      label: "Save",
      variant: "primary",
      type: "submit",
    },
  ];

  return (
    <Formik
      initialValues={{}}
      onSubmit={onFormSubmit}
      enableReinitialize
      validateOnChange={false}
      validateOnBlur={false}
    >
      {(formProps) => {
        const {
          handleChange,
          setFieldValue,
          handleSubmit,
          setValues,
          setTouched,
          values,
          setSubmitting,
          setFieldError,
          fieldValue,
          ...rest
        } = formProps;
        return (
          <Form
            autoComplete="off"
            className="h-100"
            onSubmit={handleSubmit}
            validated={!isEmpty(rest.errors)}
          >
            <ManageRkaasLayout
              buttons={buttons}
              layoutHeader={"Account Details"}
            >
              <div className="line-separator" />
              <div>
                {/*  <p className="mt-20 plan-sub-heading">Plan details</p>
                                <div className='d-flex'>
                                    <Field
                                        size="smd"
                                        isRequired
                                        name={fields.planId}
                                        label={"Plan Name"}
                                        value={get(values, fields.planId)}
                                        // disabled={isEdit && !isSave}
                                        options={planList.map((_, index) => {
                                            return {
                                                label: _.name,
                                                value: _.rkPlanNumber
                                            }
                                        })}
                                        popupContent={
                                            <SearchableList
                                                label="Select a Plan Name"
                                                // isNotTypeAhead

                                                selectedValue={get(values, fields.planId)}
                                                options={planList.map((_, index) => {
                                                    return {
                                                        label: _.name,
                                                        value: _.rkPlanNumber
                                                    }
                                                })}
                                                onSelect={(value) => {
                                                    setFieldValue(fields.planId, value);
                                                }}
                                            />
                                        }
                                        component={FieldDropSide}
                                    //validate={required}
                                    />
                                    <div className='ml-3'>
                                        <Field
                                            size="smd"
                                            isRequired
                                            name={fields.planId}
                                            label={"Plan Id"}
                                            value={get(values, fields.planId)}
                                            // disabled={isEdit && !isSave}
                                            options={planList.map((_, index) => {
                                                return {
                                                    label: _.rkPlanNumber,
                                                    value: _.rkPlanNumber
                                                }
                                            })}
                                            popupContent={
                                                <SearchableList
                                                    label="Select a Plan Id"
                                                    // isNotTypeAhead

                                                    selectedValue={get(values, fields.planId)}
                                                    options={planList.map((_, index) => {
                                                        return {
                                                            label: _.rkPlanNumber,
                                                            value: _.rkPlanNumber
                                                        }
                                                    })}
                                                    onSelect={(value) => {
                                                        setFieldValue(fields.planId, value);
                                                    }}
                                                />
                                            }
                                            component={FieldDropSide}
                                        //validate={required}
                                        />
                                    </div>
                                </div> */}
                <div>
                  <Form.Label style={{ fontSize: "14px" }}>
                    Custodian Name
                  </Form.Label>
                  <div
                    style={{
                      fontSize: "16px",
                      fontWeight: "500",
                      marginBottom: "40px",
                    }}
                  >
                    {get(outerValues, fields.custodianName)}
                  </div>
                </div>
                <Field
                  size="md"
                  isRequired
                  name={fields.custodianID}
                  label={"Custodian ID"}
                  type="text"
                  autoComplete="off"
                  value={get(values, fields.custodianID)}
                  onChange={handleChange}
                  // disabled={isEdit && !isSave}
                  component={FieldInput}
                />
                <Field
                  size="md"
                  isRequired
                  name={fields.custodianAccountNumber}
                  label={"Custodian Account Number"}
                  type="text"
                  autoComplete="off"
                  value={get(values, fields.custodianAccountNumber)}
                  onChange={handleChange}
                  // disabled={isEdit && !isSave}
                  component={FieldInput}
                />
                <Field
                  name={fields.description}
                  isRequired
                  label="Description"
                  autoComplete="off"
                  value={get(values, fields.description)}
                  onChange={handleChange}
                  // disabled={isEdit && !isSave}
                  component={FieldTextarea}
                  size="md"
                />
              </div>
              <div>
                <p className="mt-20 plan-sub-heading">Bank details</p>
                <Field
                  size="md"
                  isRequired
                  name={fields.bankAccountNumber}
                  label={"Bank account number"}
                  type="text"
                  autoComplete="off"
                  value={get(values, fields.bankAccountNumber)}
                  onChange={handleChange}
                  // disabled={isEdit && !isSave}
                  component={FieldInput}
                />
                <Field
                  isRequired
                  size="md"
                  name={fields.bankName}
                  label={"Bank name"}
                  type="text"
                  autoComplete="off"
                  value={get(values, fields.bankName)}
                  onChange={handleChange}
                  // disabled={isEdit && !isSave}
                  component={FieldInput}
                />
                <Field
                  isRequired
                  size="md"
                  name={fields.ABARoutingNumber}
                  label={"ABA routing number"}
                  type="text"
                  autoComplete="off"
                  value={get(values, fields.ABARoutingNumber)}
                  onChange={handleChange}
                  // disabled={isEdit && !isSave}
                  component={FieldInput}
                />
                {/* <Field
                                    isRequired
                                    size="sm"
                                    name={fields.bankAccountType}
                                    label={"Bank account type"}
                                    noLabelTransform
                                    options={bankAccountTypeOptions}
                                    selectedValue={get(values, fields.bankAccountType)}
                                    value={get(values, fields.bankAccountType)}
                                    onChange={(value) => {
                                        setFieldValue(fields.bankAccountType, value);
                                    }}
                                    component={FieldButtonGroup}
                                // disabled={(isEdit && !isSave) || awaitingFunding}
                                />
                                <Field
                                    isRequired
                                    size="sm"
                                    name={fields.bankAccountStatus}
                                    label={"Bank account status"}
                                    noLabelTransform
                                    options={bankAccountStatusOptions}
                                    selectedValue={get(values, fields.bankAccountStatus)}
                                    value={get(values, fields.bankAccountStatus)}
                                    onChange={(value) => {
                                        setFieldValue(fields.bankAccountStatus, value);
                                    }}
                                    component={FieldButtonGroup}
                                // disabled={(isEdit && !isSave) || awaitingFunding}
                                /> */}
              </div>
            </ManageRkaasLayout>
          </Form>
        );
      }}
    </Formik>
  );
}

export default AccountDetailsContainer;
